<template>
  <template v-if="employees.length > 0" >
    <span>
      <Percent :value="value"/>
    </span>

    <HelpMessage placement="left">
      <div class="d-flex flex-row">
        <div v-for="(chunk, chunkIndex) in chunks(employees)" class="me-1">
          <template v-for="(employee, index) in chunk">
            {{index+1+chunkIndex*chunkSize}}. {{ employee }}<br/>
          </template>
        </div>
      </div>
    </HelpMessage>
  </template>

  <template v-else>
    <Percent :value="this.value"/>
  </template>
</template>

<script>
import Percent from "./Percent";
import HelpMessage from "./HelpMessage";

const chunkSize = 25;

export default {
  name: "SharePercent",

  components: {HelpMessage, Percent},

  props: {
    value: Number,
    employees: Array,
  },

  setup() {
    return { chunkSize };
  },

  methods: {
    chunks(items) {
      const chunks = [];
      for (let i = 0; i < items.length; i += chunkSize) {
        const chunk = items.slice(i, i + chunkSize);
        chunks.push(chunk);
      }
      return chunks;
    }
  }
}
</script>

<style scoped>

</style>
